import { AdNetworkConfiguration } from 'app/core/dev-list/models/developer';
export const platforms = {
  Android: 1,
  iOS: 2,
};

export const statuses = {
  Inactive: 0,
  Active: 1,
  Invalid: 2,
  Archived: 3,
  Unavailable: 4,
};

export const adFormats = {
  Rewarded: "Rewarded Video",
  Interstitial: "Interstitial",
  Banner: "Banner",
};

export interface App {
  appId: string;
  name: string;
  windowsFilesystemCompatibleName: string;
  imageUrl: string;
  mediation: string;
  mediationId: string;
  mediationKey: string;
  platform: number;
  status: number;
  accountLinked: Date;
  accountUpdated: Date;
  optimizationStart: Date | undefined;
  benchmarkStart: Date | undefined;
  benchmarkEnd: Date | undefined;

  bundleId: string;
  category: string;
  version: string;
  publisher: string;
  storeAppId: string;
  releaseDate: Date | undefined;
  updateDate: Date | undefined;
  lastSync: Date | undefined;
  adNetworkConfigurations: AdNetworkConfiguration[];
  adUnitsEnabled: boolean;
}

export enum AppStatus {
  Inactive = 0,
  Active = 1,
  Invalid = 2,
  Archived = 3,
  Unavailable = 4,
  SystemInactive = 5,
}

export function AppRecolectorStatusList() {
  var result = (<any>Object)
    .entries(AppStatus)
    .filter(
      (e, index) =>
        !isNaN(e[0] as any) &&
        [
          AppStatus.Inactive,
          AppStatus.Active,
          AppStatus.SystemInactive,
        ].includes(index)
    )
    .map((e) => ({ name: e[1], id: +e[0] }));
  return result;
}